import { render, staticRenderFns } from "./ForgetPasswordForm.vue?vue&type=template&id=07f57f6a&scoped=true&"
import script from "./ForgetPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPasswordForm.vue?vue&type=style&index=0&id=07f57f6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f57f6a",
  null
  
)

export default component.exports